import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getAtmModel = (atmModelId: number | undefined): Promise<IGetAtmModel> => {
  return axiosDefaultApi.get(`/api/AtmModels/GetAtmModelViaID/${atmModelId}`);
};

type QueryFnType = typeof getAtmModel;

type UseGetAtmModelOptions = {
  atmModelId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAtmModel = ({ atmModelId , config }: UseGetAtmModelOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getAtmModel_${atmModelId}`],
    queryFn: () => getAtmModel(atmModelId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Μοντέλου.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};